import { MenuButtonProps, MenuItem } from "@chakra-ui/react";
import ButtonWithConfirm from "components/Button/ButtonWithConfirm";
import { titleize } from "helpers/string";
import { useNavigate } from "react-router";
import { VThreeDotMenu } from "components/Menu/ThreeDotMenu";
import useModal from "hooks/useModal";
import CaminoDuplicate from "components/Icon/CaminoDuplicate";
import CaminoDelete from "components/Icon/CaminoDelete";
import MenuItemIcon from "components/Icon/MenuItemIcon";
import { LuFlaskConical } from "react-icons/lu";
import DuplicateTemplateForm from "./DuplicateTemplateForm";
import { Template } from "../models";
import { fromTemplatePrefixId } from "../helpers";
import { useDeleteTemplate, useTestSendTemplate } from "../hooks";

interface TemplateResourceOptionMenuProps extends MenuButtonProps {
  template: Template;
  excludeTestSend?: boolean;
}

const confirmDeleteArgs = (resourceType: "email" | "message" | "task") => ({
  header: "CONFIRM you want to delete this Template",
  body: `Are you sure you want to delete this ${titleize(resourceType)} Template? This will permanently delete it and remove it from all paths`,
  confirmButtonText: "Yes, remove",
});

export default function TemplateResourceOptionMenu({
  template,
  excludeTestSend = false,
  ...rest
}: TemplateResourceOptionMenuProps) {
  const templatePrefixId = template.prefixId;
  const { templateType, resourceType } = fromTemplatePrefixId(templatePrefixId);
  const { open: openDuplicateModal, close: closeDuplicateModal, Modal: DuplicateModal } = useModal({
    headerTitle: `Duplicate ${titleize(templateType as string)}`,
    headerFontSize: "30",
    size: "lg",
  });
  const navigate = useNavigate();

  const { mutate: handeTestSend } = useTestSendTemplate(template);
  const { mutate: handleRemove } = useDeleteTemplate(template, () => {
    navigate("/");
  });

  if (!templatePrefixId) {
    return null;
  }

  return (
    <>
      <VThreeDotMenu
        ariaLabel="Options"
        {...rest}
      >
        {!excludeTestSend && (
          <MenuItem icon={<MenuItemIcon icon={LuFlaskConical} />} onClick={() => handeTestSend()}>
            Test Send to Self
          </MenuItem>
        )}
        <MenuItem icon={<MenuItemIcon icon={CaminoDuplicate} />} onClick={openDuplicateModal}>Duplicate</MenuItem>
        <ButtonWithConfirm {...confirmDeleteArgs(resourceType)} intent="confirmation" handleConfirm={() => handleRemove()}>
          <MenuItem icon={<MenuItemIcon icon={CaminoDelete} />}>Delete</MenuItem>
        </ButtonWithConfirm>
      </VThreeDotMenu>
      <DuplicateModal>
        <DuplicateTemplateForm template={template} onClose={closeDuplicateModal} />
      </DuplicateModal>
    </>
  );
}
